import { gql } from "@apollo/client"
import {
  SCHEDULE_VEHICLE_FRAG,
  VEHICLE_DETAILS_FRAG,
  VEHICLE_OWNER_FRAG,
  VEHICLE_DRIVER_FRAG,
} from "./vehicle.fragments.gql"
// Mutations
const QUICK_ADD_VEHICLE = gql`
  mutation AddQuickVehicleMutationMutation(
    $driver: PureBaseUserInput
    $owner: Int
    $registrationNumber: String
    $vehicleType: Int
  ) {
    addQuickVehicle(
      driver: $driver
      owner: $owner
      registrationNumber: $registrationNumber
      vehicleType: $vehicleType
    ) {
      vehicle {
        ...ScheduleVehicleFrag
      }
    }
  }
  ${SCHEDULE_VEHICLE_FRAG}
`

const ADD_UPDATE_VEHICLE = gql`
  mutation AddUpdateVehicleMutation(
    $chassisNumber: String
    $dateBought: Date
    $departments: [Int]
    $estimatedAverage: Float
    $id: ID
    $insurance: VehicleInsuranceInput
    $modelName: String
    $registrationNumber: String
    $vehicleType: ID
    $fuelTypeId: ID
    $fuelTankCapacity: Float
    $dimensions: [Float]
    $dimensionUnit: ID
    $vehicleKind: String
  ) {
    addUpdateVehicle(
      dimensions: $dimensions
      dimensionUnitId: $dimensionUnit
      chassisNumber: $chassisNumber
      dateBought: $dateBought
      departments: $departments
      estimatedAverage: $estimatedAverage
      id: $id
      insurance: $insurance
      modelName: $modelName
      registrationNumber: $registrationNumber
      vehicleTypeId: $vehicleType
      fuelTypeId: $fuelTypeId
      fuelTankCapacity: $fuelTankCapacity
      vehicleKind: $vehicleKind
    ) {
      vehicle {
        ...VehicleDetailsFrag
      }
    }
  }
  ${VEHICLE_DETAILS_FRAG}
`

const ADD_UPDATE_VEHICLE_OWNER = gql`
  mutation addUpdateVehicleOwnerMutation($owner: VehicleOwnerInput) {
    addUpdateVehicleOwner(owner: $owner) {
      owner {
        ...VehicleOwnerFrag

        fullName
      }
    }
  }
  ${VEHICLE_OWNER_FRAG}
`

const ADD_UPDATE_VEHICLE_DRIVER = gql`
  mutation AddUpdateVehicleDriverMutation($driver: VehicleDriverInput) {
    addUpdateVehicleDriver(driver: $driver) {
      driver {
        ...VehicleDriverFrag
        fullName
      }
    }
  }
  ${VEHICLE_DRIVER_FRAG}
`

// The id is stated as String on the mutation
const DELETE_VEHICLE = gql`
  mutation DeleteVehicleMutation($id: String) {
    delVehicle(vehicleId: $id) {
      vehicle {
        id
        registrationNumber
        status
      }
    }
  }
`

// Bulk update status

export const BULK_UPDATE_VEHICLE_STATUS = gql`
  mutation UpdateVehicleStatuses($vehicles: [ID]!, $status: String!) {
    bulkUpdateVehicleStatus(status: $status, vehicles: $vehicles) {
      vehicles {
        id
        status
      }
    }
  }
`

export const BULK_UPDATE_VEHICLE_DEPARTMENTS = gql`
  mutation BulkUpdateVehicleDepartments($vehicles: [ID]!, $departments: [ID]!) {
    bulkAddVehicleDepartment(departments: $departments, vehicles: $vehicles) {
      vehicles {
        id
        departments {
          id
          name
        }
      }
    }
  }
`
export const BULK_UPDATE_VEHICLE_VENDORS = gql`
  mutation BulkUpdateVehicleVendors($userIds: [ID!]!, $status: String!) {
    bulkUpdateVehicleUsers(userIds: $userIds, status: $status) {
      users {
        id
        status
        __typename
      }
      __typename
    }
  }
`

export {
  DELETE_VEHICLE,
  ADD_UPDATE_VEHICLE,
  ADD_UPDATE_VEHICLE_OWNER,
  QUICK_ADD_VEHICLE,
  ADD_UPDATE_VEHICLE_DRIVER,
}
